var n=function(n){return"object"==typeof n&&null!==n&&!(n instanceof Array)&&"name"in n&&"string"==typeof n.name&&"value"in n&&"string"==typeof n.value};export{n as isUrlParam};
//# sourceMappingURL=UrlParam.js.map
